"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _path;
var ChevronDown = function ChevronDown(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.145 21.903l-4.29 4.194a2 2 0 0 0-.032 2.829l43.747 44.74a2 2 0 0 0 2.86 0l43.747-44.739a2 2 0 0 0-.032-2.829l-4.29-4.194a2 2 0 0 0-2.828.031L49.43 59.363a2 2 0 0 1-2.86 0L9.973 21.934a2 2 0 0 0-2.828-.031z",
    fill: "currentColor"
  })));
};
var _default = exports.default = ChevronDown;